import {apiSlice} from './apiSlice';
import {Contactable, ContactData, ContactMethods} from '../../types/contactMethodTypes';

export const contactMethodsInjectedEndpoints = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getContactMethods: builder.query<ContactMethods, Contactable>({
            query: ({id, contactableType = 'profile'}) => `/contact_methods/?contactable_id=${id}&contactable_type=${contactableType}`,
            transformResponse: (response: ContactData[]) => {
                return response.reduce<ContactMethods>((acc, method) => {
                    if (acc[method.method]) {
                        acc[method.method].push(method);
                    } else {
                        acc[method.method] = [method];
                    }
                    return acc;
                }, {} as ContactMethods);
            },
            providesTags: ["ContactMethod"],
        }),
        updateContactMethod: builder.mutation<ContactData, ContactData>({
            query: ({id, city, province, postal_code, country, type, street_address_1, street_address_2, value}) => ({
                url: `/contact_methods/${id}`,
                method: 'PUT',
                body: {
                    city, province, postal_code, country, type, street_address_1, street_address_2, value
                },
            }),
            invalidatesTags: ["ContactMethod"],
        }),
        addContactMethod: builder.mutation<ContactData, ContactData>({
            query: (data) => ({
                url: '/contact_methods',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ["ContactMethod"],
        }),
        deleteContactMethod: builder.mutation<ContactData, number>({
            query: (id) => ({
                url: `/contact_methods/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ["ContactMethod"],
        }),
        getContactMethod: builder.query<ContactData, number>({
            query: (id): string => `/contact_methods/${id}`,
            providesTags: (result, error, id) => [{type: 'Address', id}],
        }),
    })
});

export const contactMethodEndpoints = contactMethodsInjectedEndpoints.endpoints;
export const {
    useGetContactMethodsQuery,
    useUpdateContactMethodMutation,
    useAddContactMethodMutation,
    useGetContactMethodQuery,
    useDeleteContactMethodMutation,
} = contactMethodsInjectedEndpoints;
